// extracted by mini-css-extract-plugin
module.exports = {"labeledIconContainer":"LabeledIcon_labeledIconContainer___lO_B","icon":"LabeledIcon_icon__Qqnzu","labelText":"LabeledIcon_labelText__m0gVu"};